import axios from "axios";
import { Toast } from "vant";
import "vant/es/toast/style";
import Qs from "qs";
//本地环境
//axios.defaults.baseURL = "http://192.168.111.166:9078";
// 测试环境
// axios.defaults.baseURL = "http://139.9.78.137:9078";
//axios.defaults.baseURL = "http://fuyun.viphk.nnhk.cc"
// 线上
axios.defaults.baseURL = "https://saas-pay.fuyungroup.com";
// axios.defaults.withCredentials = true
// 超时设置
axios.defaults.timeout = 120000;
// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // if (config.headers.dataType == 'json') {
    //     config.baseURL = "/baiduApi";
    // } else {
    //     config.baseURL = "https://retail.fuyungroup.com/";
    //     config.baseURL = "http://192.168.3.85:9081";
    // }
    // Do something before request is sent
    Toast.loading({
      message: "加载中...",
      forbidClick: true,
      duration: 0,
    });
    if (config.type == "form") {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }
    // config.headers.common["content-type"] = "application/json";
    config.headers["x-token"] = sessionStorage.getItem("token");
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    Toast.clear();

    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  (error) => {
    console.log(error);
    Toast.clear();
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
        // if (response.data && response.data.code > 0) {
        //     Toast(response.data.msg);
        //     reject(response);
        // } else {
        //     resolve(response.data);
        // }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
export function postJ(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, Qs.stringify(data)).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function del(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
let timeout = null;

/**
 * 防抖原理：一定时间内，只有最后一次操作，再过wait毫秒后才执行函数
 *
 * @param {Function} func 要执行的回调函数
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行
 * @return null
 */
function debounce(func, wait = 500, immediate = false) {
  // 清除定时器
  if (timeout !== null) clearTimeout(timeout);
  // 立即执行，此类情况一般用不到
  if (immediate) {
    var callNow = !timeout;
    timeout = setTimeout(function () {
      timeout = null;
    }, wait);
    if (callNow) typeof func === "function" && func();
  } else {
    // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
    timeout = setTimeout(function () {
      typeof func === "function" && func();
    }, wait);
  }
}

export default {
  get,
  post,
  postJ,
  patch,
  put,
  del,
  debounce,
};
